import { cleaningServices } from "../data/content";

function CleaningSection() {
  return (
    <section id="cleaning" className="section alt">
      <div className="section-title">
        <p>Deep Cleaning</p>
        <h2>Healthier Air & Better Performance</h2>
      </div>
      <div className="grid">
        {cleaningServices.map((service) => (
          <article key={service.title} className="card light">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default CleaningSection;
